export function TokenValuesInfoCell({
  value,
  usd,
  symbol,
  singleLine,
}: {
  value: string;
  usd?: string;
  symbol?: string;
  singleLine?: boolean;
}) {
  const isNumber = !isNaN(Number(value.replace(/,/g, "")));
  const content = <>{usd && <div className="whitespace-nowrap ">{usd}</div>}</>;
  return singleLine ? <div className="flex gap-4">{content}</div> : content;
}
